// import React from "react";
// import { Link } from "react-router-dom";
// import { getDateAgo } from "../../helper/Helper";

// function relatedCard({ item }) {
//   return (
//     <div className="custom-relatedblog-card">
//       {/* LEFT IMAGE */}
//       <div className="custom-relatedblog-img">
//         <Link to={`/blog/${item?.slug}`}>
//           <img src={item?.image} alt={item?.title} />
//         </Link>
//       </div>

//       {/* RIGHT CONTENT */}
//       <div className="custom-relatedblog-content">
//         <ul className="custom-relatedblog-meta mb-0">
//           {item?.createdAt && <li>{getDateAgo(item.createdAt)}</li>}

//         </ul>

//         <Link to={`/blog/${item?.slug}`} className="custom-relatedblog-title">
//           {item?.title}
//         </Link>

//         <p className="custom-relatedblog-desc">{item?.shortDescription}</p>

//         <Link to={`/blog/${item?.slug}`} className="custom-relatedblog-read">
//           Read more →
//         </Link>
//       </div>
//     </div>
//   );
// }

// export default relatedCard;


import React from "react";
import { Link } from "react-router-dom";
import { getDateAgo } from "../../helper/Helper";

function relatedCard({ item }) {
  return (
  <div
  className="group overflow-hidden rounded-2xl border transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
  style={{
    backgroundColor: "var(--color-white)",
    borderColor: "var(--color-border)",
  }}
>
  {/* TOP IMAGE */}
  <div className="w-full overflow-hidden">
    <Link to={`/blog/${item?.slug}`}>
      <img
        src={item?.image}
        alt={item?.title}
        className="w-full aspect-[16/10] object-cover transition-transform duration-500 group-hover:scale-105"
      />
    </Link>
  </div>

  {/* CONTENT */}
  <div className="p-4">
    <ul
      className="mb-2 flex items-center gap-2 text-xs font-medium uppercase tracking-wider"
      style={{
        color: "var(--color-accent-gold)",
        fontFamily: "var(--font-body)",
      }}
    >
      {item?.createdAt && <li>{getDateAgo(item.createdAt)}</li>}
    </ul>

    <Link
      to={`/blog/${item?.slug}`}
      className="text-lg leading-snug font-semibold transition-colors duration-300 line-clamp-2"
      style={{
        color: "var(--color-secondary)",
        fontFamily: "var(--font-heading)",
      }}
      onMouseEnter={(e) =>
        (e.currentTarget.style.color = "var(--color-primary)")
      }
      onMouseLeave={(e) =>
        (e.currentTarget.style.color = "var(--color-secondary)")
      }
    >
      {item?.title}
    </Link>

    <p
      className="mt-2 text-sm leading-6 line-clamp-3"
      style={{
        color: "var(--color-text-muted)",
        fontFamily: "var(--font-body)",
      }}
    >
      {item?.shortDescription}
    </p>

    <Link
      to={`/blog/${item?.slug}`}
      className="mt-3 inline-flex items-center gap-2 text-sm font-semibold transition-all duration-300 hover:gap-3"
      style={{
        color: "var(--color-primary)",
        fontFamily: "var(--font-body)",
      }}
    >
      Read more <span>→</span>
    </Link>
  </div>
</div>
  );
}

export default relatedCard;